<template>
  <div class="s-charts">
    <div class="s-charts-items s-charts-items_active">
      <div class="s-chart s-chart_dynamic">
        <c-switcher
          v-model="dynamicsChart.switcher"
          class="s-chart-switcher"
          type="group"
          :items="[
            { icon: 'ruble', value: 'ruble' },
            { icon: 'percent', value: 'percent' },
          ]"
        />

        <highcharts class="s-chart-chart" :options="dynamicsChart.options" />
      </div>

      <div class="s-chart s-chart_branches">
        <c-switcher
          v-model="branchesChart.switcher"
          class="s-chart-switcher"
          type="group"
          :items="[
            { icon: 'ruble', value: 'ruble' },
            { icon: 'percent', value: 'percent' },
          ]"
        />

        <highcharts class="s-chart-chart" :options="branchesChart.options" />
      </div>

      <div class="s-chart s-chart_pie flex-grow-1">
        <highcharts class="s-chart-chart" :options="positionsChart.options" />
      </div>
    </div>
  </div>
</template>

<script>
import { Chart } from "highcharts-vue";
import Highcharts from "highcharts";
import exportingInit from "highcharts/modules/exporting";
import moment from "moment";
import { mapGetters } from "vuex";
import queryString from "query-string";

import Switcher from "@/components/controls2/Switcher";

moment.locale("ru");

exportingInit(Highcharts);

export default {
  name: "s-charts",
  components: {
    "c-switcher": Switcher,
    "highcharts": Chart,
  },

  props: ["active"],

  data() {
    return {
      dynamicsChart: {
        switcher: "ruble",
        options: {
          lang: {
            exitFullscreen: "Выйти из режима на весь экран",
            viewFullscreen: "Развернуть на весь экран",
            loading: "Загрузка...",
            months: [
              "Январь",
              "Февраль",
              "Март",
              "Апрель",
              "Май",
              "Июнь",
              "Июль",
              "Август",
              "Сентябрь",
              "Октябрь",
              "Ноябрь",
              "Декабрь",
            ],
            weekdays: ["Воскресенье", "Понедельник", "Вторник", "Среда", "Четверг", "Пятница", "Суббота"],
            shortMonths: ["Янв", "Фев", "Март", "Апр", "Май", "Июнь", "Июль", "Авг", "Сент", "Окт", "Нояб", "Дек"],
            exportButtonTitle: "Экспорт",
            printButtonTitle: "Печать",
            rangeSelectorFrom: "С",
            rangeSelectorTo: "По",
            rangeSelectorZoom: "Период",
            downloadPNG: "Скачать PNG",
            downloadJPEG: "Скачать JPEG",
            downloadPDF: "Скачать PDF",
            downloadSVG: "Скачать SVG",
            printChart: "Напечатать график",
          },
          navigation: {
            buttonOptions: {
              theme: {
                "stroke-width": 1,
                "stroke": "#D3D8DF",
                "r": 15,
              },
            },
          },
          credits: false,
          title: {
            text: "Динамика",
            align: "left",
            x: -10,
            y: 10,
            style: {
              color: "#000000",
              fontWeight: "500",
              fontSize: "15px",
              lineHeight: "120%",
              fontFamily: "Fira Sans",
            },
          },
          chart: { type: "column", height: 280, marginTop: 46 },
          xAxis: {
            categories: [],
            labels: {
              step: 1,
              style: {
                fontFamily: "Fira Sans",
                fontSize: "10px",
                lineHeight: "12px",
                color: "#8E9CBB",
              },
            },
            crosshair: true,
          },
          yAxis: {
            min: 0,
            max: 2000,
            title: {
              text: "Оборот/ФОТ, ฿",
              x: -10,
              margin: 0,
              style: {
                fontFamily: "Fira Sans",
                fontSize: "10px",
                lineHeight: "12px",
                color: "#000000",
              },
            },
            labels: {
              style: {
                fontFamily: "Fira Sans",
                fontSize: "10px",
                lineHeight: "12px",
                color: "#8E9CBB",
              },
            },
            tickAmount: 5,
          },
          tooltip: {
            outside: true,
          },
          legend: { enabled: false },
          plotOptions: {
            column: {
              stacking: "normal",
            },
          },
          series: [
            { name: "Оборот", data: [], color: "#0066FF" },
            { name: "ФОТ", data: [], color: "#74ACFF" },
          ],
          exporting: {
            buttons: {
              contextButton: {
                y: -10,
                x: 0,
                height: 30,
                width: 31,
                symbolSize: 12,
                symbolStrokeWidth: 2,
                symbolStroke: "#8E9CBB",
                symbolX: 15.5,
                symbolY: 14.5,
                menuItems: [
                  "viewFullscreen",
                  "printChart",
                  "downloadPNG",
                  "downloadJPEG",
                  "downloadPDF",
                  "downloadSVG",
                ],
              },
            },
          },
        },
      },
      branchesChart: {
        switcher: "ruble",
        options: {
          lang: {
            exitFullscreen: "Выйти из режима на весь экран",
            viewFullscreen: "Развернуть на весь экран",
            loading: "Загрузка...",
            months: [
              "Январь",
              "Февраль",
              "Март",
              "Апрель",
              "Май",
              "Июнь",
              "Июль",
              "Август",
              "Сентябрь",
              "Октябрь",
              "Ноябрь",
              "Декабрь",
            ],
            weekdays: ["Воскресенье", "Понедельник", "Вторник", "Среда", "Четверг", "Пятница", "Суббота"],
            shortMonths: ["Янв", "Фев", "Март", "Апр", "Май", "Июнь", "Июль", "Авг", "Сент", "Окт", "Нояб", "Дек"],
            exportButtonTitle: "Экспорт",
            printButtonTitle: "Печать",
            rangeSelectorFrom: "С",
            rangeSelectorTo: "По",
            rangeSelectorZoom: "Период",
            downloadPNG: "Скачать PNG",
            downloadJPEG: "Скачать JPEG",
            downloadPDF: "Скачать PDF",
            downloadSVG: "Скачать SVG",
            printChart: "Напечатать график",
          },
          navigation: {
            buttonOptions: {
              theme: {
                "stroke-width": 1,
                "stroke": "#D3D8DF",
                "r": 15,
              },
            },
          },
          credits: false,
          title: {
            text: "Филиалы",
            align: "left",
            x: -10,
            y: 10,
            style: {
              color: "#000000",
              fontWeight: "500",
              fontSize: "15px",
              lineHeight: "120%",
              fontFamily: "Fira Sans",
            },
          },
          tooltip: {
            outside: true,
          },
          chart: {
            type: "column",
            height: 280,
            marginTop: 46,
          },
          xAxis: {
            categories: [],
            crosshair: true,
            labels: {
              style: {
                fontFamily: "Fira Sans",
                fontSize: "10px",
                lineHeight: "12px",
                color: "#000000",
              },
            },
          },
          yAxis: {
            min: 0,
            max: 2000,
            title: {
              text: "Оборот/ФОТ, %",
              x: -12,
              margin: 0,
              style: {
                fontFamily: "Fira Sans",
                fontSize: "10px",
                lineHeight: "12px",
                color: "#000000",
              },
            },
            labels: {
              style: {
                fontFamily: "Fira Sans",
                fontSize: "10px",
                lineHeight: "12px",
                color: "#8E9CBB",
              },
            },
            tickAmount: 5,
          },
          legend: { enabled: false },
          plotOptions: {
            column: {
              stacking: "normal",
              events: {
                click: this.onClickBranchesChart,
              },
            },
          },
          series: [
            { name: "Оборот", data: [], color: "#0066FF" },
            { name: "ФОТ", data: [], color: "#74ACFF" },
          ],
          exporting: {
            buttons: {
              contextButton: {
                y: -10,
                x: 0,
                height: 30,
                width: 31,
                symbolSize: 12,
                symbolStrokeWidth: 2,
                symbolStroke: "#8E9CBB",
                symbolX: 15.5,
                symbolY: 14.5,
                menuItems: [
                  "viewFullscreen",
                  "printChart",
                  "downloadPNG",
                  "downloadJPEG",
                  "downloadPDF",
                  "downloadSVG",
                ],
              },
            },
          },
        },
      },
      positionsChart: {
        options: {
          lang: {
            exitFullscreen: "Выйти из режима на весь экран",
            viewFullscreen: "Развернуть на весь экран",
            loading: "Загрузка...",
            months: [
              "Январь",
              "Февраль",
              "Март",
              "Апрель",
              "Май",
              "Июнь",
              "Июль",
              "Август",
              "Сентябрь",
              "Октябрь",
              "Ноябрь",
              "Декабрь",
            ],
            weekdays: ["Воскресенье", "Понедельник", "Вторник", "Среда", "Четверг", "Пятница", "Суббота"],
            shortMonths: ["Янв", "Фев", "Март", "Апр", "Май", "Июнь", "Июль", "Авг", "Сент", "Окт", "Нояб", "Дек"],
            exportButtonTitle: "Экспорт",
            printButtonTitle: "Печать",
            rangeSelectorFrom: "С",
            rangeSelectorTo: "По",
            rangeSelectorZoom: "Период",
            downloadPNG: "Скачать PNG",
            downloadJPEG: "Скачать JPEG",
            downloadPDF: "Скачать PDF",
            downloadSVG: "Скачать SVG",
            printChart: "Напечатать график",
          },
          navigation: {
            buttonOptions: {
              theme: {
                "stroke-width": 1,
                "stroke": "#D3D8DF",
                "r": 15,
              },
            },
          },
          credits: false,
          chart: {
            height: 202,
            margin: [30, 0, 50, 0],
            style: {
              fontFamily: "Fira Sans",
            },
          },
          title: {
            text: "Распределение по должностям",
            useHTML: true,
            align: "left",
            x: -10,
            y: 10,
            style: {
              color: "#000000",
              fontWeight: "500",
              fontSize: "15px",
              lineHeight: "120%",
              fontFamily: "Fira Sans",
            },
          },
          legend: {
            align: "right",
            labelFormat: "<b>{percentage:,.1f}%</b> {name}",
            layout: "vertical",
            itemMarginBottom: 12,
            itemStyle: {
              fontWeight: "normal",
              fontSize: "11px",
              lineHeight: "200%",
            },
            verticalAlign: "middle",
            y: 25,
          },
          plotOptions: {
            pie: {
              dataLabels: {
                enabled: false,
              },
              size: 160,
              showInLegend: true,
              center: [70, 70],
              events: {
                click: this.onClickPositionsChart,
              },
            },
          },
          tooltip: {
            pointFormat: "<strong>{point.y}%</strong>",
            style: {opaсity:"0!important"},
            className: "no-opacity",

          },
          series: [
            {
              type: "pie",
              innerSize: "60%",
              data: [],
            },
          ],
          exporting: {
            buttons: {
              contextButton: {
                y: -10,
                x: 0,
                height: 30,
                width: 31,
                symbolSize: 12,
                symbolStrokeWidth: 2,
                symbolStroke: "#8E9CBB",
                symbolX: 15.5,
                symbolY: 14.5,
                menuItems: [
                  "viewFullscreen",
                  "printChart",
                  "downloadPNG",
                  "downloadJPEG",
                  "downloadPDF",
                  "downloadSVG",
                ],
              },
            },
          },
          responsive: {
            rules: [
              {
                condition: {
                  maxWidth: 375,
                },
                chartOptions: {
                  legend: {
                    align: "center",
                    verticalAlign: "bottom",
                    itemMarginBottom: 8,
                    y: 12,
                  },
                  plotOptions: {
                    pie: {
                      center: [null, 85],
                    },
                  },
                  chart: {
                    height: 350,
                    margin: [19, 0, 50, 0],
                  },
                },
              },
            ],
          },
        },
      },
      positions: null,
    };
  },

  computed: {
    ...mapGetters("test", ["getBranches", "getBranchesById", "getBranchesByIdNot", "getPositions"]),
    ...mapGetters("calculations", ["getStat"]),
  },

  watch: {
    "dynamicsChart.switcher": function (value) {
      this.dynamicsChart.options.plotOptions.column.stacking = value === "percent" ? "percent" : "normal";
      this.dynamicsChart.options.yAxis.max = value === "percent" ? 100 : 2000;
      this.dynamicsChart.options.yAxis.title.text = value === "percent" ? "Оборот/ФОТ, %" : "Оборот/ФОТ, ฿";

      if (this.$route.query) {
        const str = this.$route.fullPath.split("?")[1];
        const query = queryString.parse(str, { arrayFormat: "index", parseBooleans: true });
        this.initDynamicsChart(query);
      }
    },
    "branchesChart.switcher": function (value) {
      this.branchesChart.options.plotOptions.column.stacking = value === "percent" ? "percent" : "normal";

      this.branchesChart.options.yAxis.title.text = value === "percent" ? "Оборот/ФОТ,  %" : "Оборот/ФОТ,  ฿";

      if (this.$route.query) {
        const str = this.$route.fullPath.split("?")[1];
        const query = queryString.parse(str, { arrayFormat: "index", parseBooleans: true });
        this.initBranchesChart(query);
      }
    },

    "$route": function (from) {
      if (from && from.query) {
        const str = from.fullPath.split("?")[1];
        const query = queryString.parse(str, { arrayFormat: "index", parseBooleans: true });
        this.initDynamicsChart(query);
        this.initBranchesChart(query);
      }
    },
  },

  mounted() {
    if (this.$route.query) {
      const str = this.$route.fullPath.split("?")[1];

      this.$store.dispatch("calculations/getStat", [str]).then(() => {
        this.initPositionsChart();
        this.initBranchesChart();
        this.initDynamicsChart();
      });
    }
  },

  methods: {
    onClickBranchesChart() {
      this.initPositionsChart();
    },

    onClickPositionsChart() {
      if (this.$route.query) {
        const str = this.$route.fullPath.split("?")[1];
        const query = queryString.parse(str, { arrayFormat: "index", parseBooleans: true });
        this.initBranchesChart(query);
      }
    },

    initPositionsChart() {
      const stat = this.getStat;

      const data = [];

      if (stat.total_paid > 0) {
        Object.keys(stat.posts).forEach((p) => {
          const post = stat.posts[p];
          if (post.paid > 0) {
            data.push({
              name: post.name,
              y: Math.round((post.paid / stat.total_paid) * 100 * 10) / 10,
              // color: position.color,
            });
          }
        });
      }

      data.sort((a, b) => b.y - a.y);

      this.positions = data;
      this.positionsChart.options.series[0].data = data;
    },
    initBranchesChart() {
      const stat = this.getStat;

      const branchCols = [];
      const branchFotCols = [];
      const branchLabels = [];

      let max = 0;

      Object.keys(stat.filials).forEach((bi) => {
        const branch = stat.filials[bi];
        if (branch.sum > 0) {
          branchLabels.push(branch.name);

          let sum = Math.round(branch.sum );
          if (max < sum) max = sum;
          let paid = Math.round(branch.paid );
          if (this.branchesChart.switcher === "percent") {
            paid = Math.round((branch.paid / branch.sum) * 100);
            sum = 100 - paid;
          }

          branchCols.push({
            name: branch.name,
            branchId: branch.id,
            y: sum,
            seriesName: "Оборот",
          });

          branchFotCols.push({
            name: branch.name,
            branchId: branch.id,
            y: paid,
            seriesName: "ФОТ",
          });
        }
      });

      this.branchesChart.options.yAxis.max = this.branchesChart.switcher === "percent" ? 100 : max;
      this.branchesChart.options.xAxis.categories = branchLabels;
      this.branchesChart.options.series[0].data = branchCols;
      this.branchesChart.options.series[1].data = branchFotCols;
    },

    initDynamicsChart() {
      const stat = this.getStat.periods;

      const data = [];
      Object.keys(stat).forEach((i) => data.push(stat[i]));

      data.sort((a, b) => a.sort - b.sort);

      const columns = [];
      const columnsFot = [];
      const columnsLabel = [];
      let max = 0;

      for (let i = 0; i < data.length; i++) {
        const period = data[i];

        const label = period.name;

        let sum = Math.round(period.sum );
        if (max < sum) max = sum;
        let paid = Math.round(period.paid );
        if (this.dynamicsChart.switcher === "percent") {
          paid = Math.round((period.paid / period.sum) * 100);
          sum = 100 - paid;
        }

        columns.push(Math.round(sum));
        columnsFot.push(Math.round(paid));
        columnsLabel.push(label);
      }

      this.dynamicsChart.options.xAxis.categories = columnsLabel;
      this.dynamicsChart.options.yAxis.max = this.dynamicsChart.switcher === "percent" ? 100 : max;
      // this.dynamicsChart.options.xAxis.labels.step = step;
      this.dynamicsChart.options.series[0].data = columns;
      this.dynamicsChart.options.series[1].data = columnsFot;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/vars";

.s-charts {
  position: relative;
  z-index: 1;

  &-items {
    width: 100%;
    display: flex;
    opacity: 0;
    height: 0;
    visibility: hidden;
    transition: 0.2s;
    margin-left: -30px;

    &_active {
      width: calc(100% + 30px);
      height: auto;
      opacity: 1;
      visibility: visible;
    }

    @media (max-width: 1419px) {
      flex-wrap: wrap;
    }

    @media screen and (max-width: 767px) {
      width: 100%;
      margin-left: 0;
    }
  }

  &-summary {
    padding-top: 20px;

    @media (max-width: 789px) {
      padding-top: 0;
    }
  }
}

.s-chart {
  width: 33.3333333%;
  position: relative;
  z-index: 0;
  box-sizing: border-box;

  @media (max-width: 789px) {
    border: 0 !important;

    &:first-child {
      border-top: 1px solid $color-border-alt;
    }

    &:last-child {
      border-bottom: 1px solid $color-border-alt;
    }
  }

  &:first-child {
    padding-left: 0;
  }

  &:last-child {
    padding-right: 0;
  }

  &-switcher {
    position: absolute;
    z-index: 20;
    right: 58px;
  }

  &-chart {
    position: relative;
    z-index: 10;
    padding-left: 30px;

    @media screen and (max-width: 767px) {
      padding-left: 0;
    }
  }

  @media (max-width: 1419px) {
    width: 50%;
    margin-bottom: 16px;

    &:last-child {
      margin-bottom: 0;
      border-top: 0;
      padding-left: 0;
    }
  }

  @media (max-width: 767px) {
    width: 100%;
    padding-left: 0;
    height: auto;

    &:last-child {
      border-top: 1px solid $color-border-alt;
    }
  }

  &_dynamic,
  &_branches {
    //margin-right: 15px;
  }

  &_pie {
    display: flex;
    flex-grow: 0;
    max-width: 420px;
    min-width: 420px;

    @media (max-width: 767px) {
      flex-direction: column;
      height: auto;
      margin-bottom: 11px !important;

      .s-chart-chart {
        width: 100%;
      }
    }
  }
}

::v-deep .highcharts-exporting-group {
  border: 1px solid #d3d8df;
  box-sizing: border-box;
  border-radius: 50%;
}

::v-deep .highcharts-title {
  white-space: nowrap !important;
  text-overflow: ellipsis !important;
  overflow: hidden !important;
}

.no-opacity {
  opacity: 0!important;
}
</style>
